module.exports = __webpack_public_path__ + "img/zx4.908189ed.png";